export default "__VITE_ASSET__1d7143c1__"